import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BaseReportTableComponent } from 'src/app/features/reports/components/base-report-table/base-report-table.component';
import { TableColumn, TableStructure } from '@shared/components/table/models/table-structure.model';
import { SpeechStatsReportRecord } from 'src/app/features/reports/components/report-filters/models/report-data.model';
import { SimpleReportTableComponentModule } from '@src/app/features/reports/components/simple-report-table/simple-report-table.component';
import { SimpleReportTableComponent } from '../../../../components/simple-report-table/simple-report-table.component';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';
import { ReportType } from '@src/app/features/reports/components/report-filters/models/report-filters.model';

@Component({
  selector: 'stx-speech-stats-report-table',
  templateUrl: './speech-stats-report-table.component.html',
  imports: [MatPaginator, SimpleReportTableComponent, EmptyTableStateComponent]
})
export class SpeechStatsReportTableComponent extends BaseReportTableComponent<SpeechStatsReportRecord> implements OnInit, OnDestroy {
  readonly reportType: ReportType = 'SPEECH_STATS';
  displayedColumns: string[] = [];
  columns: TableColumn[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.onInit();

    this.subSink.sink = this.reportTableDataService.tableStructure$.subscribe((tableStructure: TableStructure<{ [key: string]: any }>) => {
      this.columns = tableStructure?.labels || [];
      this.displayedColumns = this.columns.map(a => a.name);
    });
  }

  ngOnDestroy(): void {
    super.onDestroy();
  }
}

@NgModule({
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    SimpleReportTableComponentModule,
    SpeechStatsReportTableComponent
  ],
  exports: [SpeechStatsReportTableComponent]
})
export class SpeechStatsReportTableComponentModule {}
